import React, { useState } from 'react';
import { InputText } from 'primereact/inputtext';
import { MultiSelect } from 'primereact/multiselect';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from "primereact/dropdown";
import { LookupField } from '../../../components/lookup/LookupField';
import '../../../index.scss'
import * as IconFactory from "../../../services/icons.factory";

export const DeliveryManagementAppFilter = (props) => {

    //controla o span do botão compartilhar
    const [showOptions, setShowOptions] = useState(false);

    const handleButtonClick = () => {
        setShowOptions(!showOptions);
    };

    return (
        <div className="carrier-form">
            <div className="p-grid">
                <div className="p-col-12">
                    <div className="p-grid">
                    </div>
                    <div className="p-grid">
                        <div className="p-col-2 form-field-container">
                            <label className="lxRequiredField">De</label>
                            <Calendar showIcon={true} value={props.customFilter.initialDateFilter} showTime={false} onChange={props.initialDateChangeHandler} disabled={false} name="initialDateFilter" dateFormat="dd/mm/yy" />
                        </div>
                        <div className="p-col-2 form-field-container">
                            <label className="lxRequiredField">Até</label>
                            <Calendar showIcon={true} value={props.customFilter.finalDateFilter} showTime={false} onChange={props.finalDateChangeHandler} disabled={false} name="finallDateFilter" dateFormat="dd/mm/yy" />
                        </div>
                        <div className="p-col-2 form-field-container">
                            <label>Situação</label>
                            <MultiSelect value={props.currentFilterDeliveryStatus} options={props.deliveryStatusOptions} onChange={props.handleChangeDeliveryStatus}></MultiSelect>
                        </div>
                        <div className="p-col-1 form-field-container">
                            <br />
                            <button
                                className="lognex-btn-highlighted"
                                style={{ width: "100%" }}
                                title="Filtrar"
                                onClick={props.applyTrackingFilter}>
                                Filtrar
                            </button>
                        </div>
                        <div className="p-col-1 form-field-container" style={{ position: 'relative' }}>
                            <br />
                            <button
                                className="lognex-btn-highlighted-inverse"
                                style={{ width: "100%" }}
                                title="Compartilhar"
                                onClick={handleButtonClick}
                                disabled={false}
                            >
                                Compartilhar
                            </button>

                            {showOptions && (
                                <span
                                    className="share-options"
                                    style={{
                                        position: 'absolute',
                                        top: '100%',
                                        left: '12',
                                        zIndex: '999',
                                        marginTop: '5px',
                                        border: '1px solid #ccc',
                                        borderRadius: '5px',
                                        padding: '10px',
                                        backgroundColor: '#fff',
                                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                                    }}
                                >                                    <button
                                    className="lognex-btn-highlighted-inverse"
                                    style={{
                                        width: "100%",
                                        marginBottom: '10px',
                                    }}
                                    title="Download"
                                    onClick={() => console.log('Exportar relatório')}
                                    disabled={!props.enabledExportCSV}
                                >
                                        Relatório
                                    </button>
                                    <button
                                        className="lognex-btn-highlighted-inverse"
                                        onClick={() => console.log('Compartilhar por WhatsApp')}
                                        title="Compartilhar no WhatsApp"
                                        style={{
                                            width: '100%',
                                            marginBottom: '10px',
                                        }}
                                    >
                                        WhatsApp
                                    </button>
                                    <button
                                        style={{
                                            width: '100%',
                                        }}
                                        className="lognex-btn-highlighted-inverse"
                                        onClick={() => console.log('Compartilhar por Email')}
                                        title="Compartilhar por E-mail"
                                    >
                                        E-mail
                                    </button>
                                </span>
                            )}

                        </div>
                        <div className="p-col-1 form-field-container">
                            <br />
                            <button
                                className="lognex-btn-highlighted-inverse"
                                style={{ width: "100%" }}
                                title="Download"
                                onClick={props.onSetMapGeral}
                            >
                                Mapa Geral
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
